<template>
  <div class="tabs-list" style="margin-bottom: 75px">
    <template v-for="(item, $index) in tabs[0].list">
      <div class="tab-item" @click="goDetail(item)" :key="$index">
        <p class="tab-title">{{item.title}}</p>
        <div class="tab-label">
          <label>{{item.media || item.source}}</label>
          <span>{{item.ctime * 1000 | showtime}}</span>
          <!-- <span v-if="item.formatdate">{{item.formatdate}}</span> -->
        </div>
      </div>
      <div v-if="$index==3 && ad" class="tab-item" :key="item.id">
        <Ad width="3.45rem" height="0.6rem" :content="ad" />
      </div>
    </template>
    <infinite-loading ref="zixuninf" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
      <div slot="no-more">无更多数据</div>
      <div v-if="tabs[0].list.length === 0" slot="no-results" class="no-results">
      </div>
      <div v-else slot="no-results">
      </div>
      <div slot="spinner" class="tab-spinner">正在加载...</div>
    </infinite-loading>
  </div>
</template>

<script>
import moment from 'moment'
import InfiniteLoading from 'vue-infinite-loading'
import { request } from '@/api/request'
import {mapState} from 'vuex'
import Ad from '../../advertisement/index.vue'

let ORDER = null // 港股指数分页参数字段

export default {
  computed: {
    ...mapState({
      code: state => state.code,
      symbol: state => state.symbol,
      market: state => state.market,
      isIndex: state => state.isIndex,
      region: state => state.region,
      tabs: state => state.common.tabs,
      tabIndex: state => state.common.tabIndex,
      ad: state => state.homeAdList[0]
    })
  },
  components: { InfiniteLoading, Ad },
  activated() {
    this.$refs.zixuninf.stateChanger.reset()
  },
  methods: {
    goDetail(zixun) {
      const {news_id, url} = zixun
      this.$router.push(`/detail/${this.market}/${this.symbol}/1/${news_id}.html${url ? `?url=${encodeURIComponent(url)}` : ''}`)
    },
    async infiniteHandler($state) {
      let canload = await this.getListData()
      if (canload) $state.loaded()
      else $state.complete()
    },
    /**
     * 获取list 数据
     */
    async getListData() {
      if (this.region === 'HK' && this.isIndex) {
        let params = {
          appCode:'com.sina.ggt',
          showPermission:2,
          type: 'hkstock'
        }
        if (ORDER) {
          params = Object.assign({} , params, {
            order: ORDER,
            limit: 30
          })
        }
        let res = await request._get(request.apis.news.getUkIndexNewsList, params, true)
        if (res.length) {
          const list = res.map(item => ({
            ...item,
            ctime: new Date(item.createdatetime).getTime() / 1000,
          }))
          this.tabs[0].list = this.tabs[0].list.concat(list)
          ORDER = res[res.length - 1].order
          return true
        } 
        return false
      } else {
        let res = await request.get({
          url: request.apis.quote.articles,
          params: {
            market: this.market === 'HKIDX' ? 'HKSE' : this.market.toLowerCase(),
            symbol: this.symbol,
            pageNo: this.tabs[0].pageNo++,
            pageSize: 30,
            types: 1
          }
        })
        this.tabs[0].list = this.tabs[0].list.concat(res.list)
        if (res.list.length > 0) return true
        else return false
      }
    }
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.tabs-list
  display flex
  flex-flow column
  min-height 100vh
  .no-results
    background url('../../../assets/no_data.png')
    height 200px
    width 200px
    background-size cover
    margin 50px auto
  .tab-spinner
    font-size 13px
    padding 15px 0 30px 0
    color: #999
  .tab-item
    padding 10px 8px
    border-bottom 1px solid #f5f5f5
    .tab-title
      font-size 15px
      color #333
      // height 22px
      line-height 21px
      font-weight 400
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
    .tab-label
      display flex
      justify-content space-between
      font-size 12px
      color #999
      margin-top 5px
</style>